import type { ReactElement } from 'react'
import { Box, Tooltip } from '@mui/material'
import type { TooltipProps } from '@mui/material/Tooltip'
import { shortenString } from '@utils'

export type TruncatingTooltipProps = {
  text: string
  /** When `text.length` exceeds this, it is shortened with `...` and the full string is shown in a tooltip. */
  maxLength?: number
  /** Passed through when truncation applies. */
  tooltipProps?: Omit<TooltipProps, 'children' | 'title'>
}

export const TruncatingTooltip = ({
  text,
  maxLength = 10,
  tooltipProps,
}: TruncatingTooltipProps): ReactElement => {
  if (text.length <= maxLength) {
    return <span>{text}</span>
  }

  const displayText = shortenString(text, maxLength)

  return (
    <Tooltip title={text} arrow placement="top" {...tooltipProps}>
      <Box
        component="span"
        sx={{
          cursor: 'default',
          display: 'inline',
        }}
      >
        {displayText}
      </Box>
    </Tooltip>
  )
}
